var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckboxChecked = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 32v31h62V1H1v31zm38.5 0C34 37.5 29 42 28.4 42c-.6 0-3.3-2.3-5.9-5.1l-4.8-5.1 2.2-2.1 2.1-2.2 3.2 3.2 3.2 3.3 8.4-8.2 8.3-8.1 2.2 2.1 2.2 2.2-10 10z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckboxChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkbox_checked.32136e8c.svg";
export { ForwardRef as ReactComponent };